import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Package, Permission } from "types";
import { IsGranted } from "../../components/Common/IsGranted";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { ProductSearch } from "../../components/Product/ProductSearch";
import { useAutoFetchCollection } from "../../hooks/useAutoFetchCollection";
import { useSearch } from "../../hooks/useSearch";
import { Page } from "../Page";
import { PartnerPackageList } from "@/components/Product/PartnerPackages/PartnerPackageList";

export const PartnerPackageListPage = () => {
    const [search, setSearch] = useState("");
    const { data: partnerPackages, isLoading } = useAutoFetchCollection<Package>("partnerPackages");
    let filtered = useSearch(partnerPackages, (pkg) => [pkg.name, pkg.id], search);
    filtered = orderBy(filtered, (pkg) => pkg.name, ["asc"]);
    const isFiltered = search.length > 0;

    const history = useHistory();

    const handleCreate = () => {
        history.push(`/products/partnerPackages/new`);
    };

    return (
        <Page title="Partner Packages">
            <ColumnLayout>
                <HeaderToolbar className="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item>Partner Packages</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ProductSearch onSearch={setSearch} />

                    <IsGranted permissions={Permission.PARTNER_PACKAGES_MODIFY}>
                        <Button color="primary" className="flex-shrink-0" icon={<PlusIcon />} onClick={handleCreate}>
                            Create Partner Package
                        </Button>
                    </IsGranted>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <PartnerPackageList packages={filtered} isLoading={isLoading} isFiltered={isFiltered} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
